import React from 'react'
import styled from '@emotion/styled'

import { Flex } from 'lese'
import Link from 'Components/Link'
import { colors } from 'Constants'

const CardButton = styled(Flex)`
  border: 1px solid ${colors.borderColor};
  padding: 8px;
  color: ${() => colors.secondary};
  height: 100%;
  box-sizing: border-box;
  cursor: pointer;
`

export default ({ header, title, children, href, ...props }) => {
  return href ? (
    <Link href={href}>
      <CardButton yAlign separation="8px" {...props}>
        {children}
      </CardButton>
    </Link>
  ) : (
    <CardButton yAlign separation="8px" {...props}>
      {children}
    </CardButton>
  )
}
